export const numpadKeyboardButtonTypes = [
  '1',
  '2',
  '3',
  '4',
  '5',
  <span className='icon-clear' />,
  '6',
  '7',
  '8',
  '9',
  '0',
  '.',
];
